import {useDispatch, useSelector} from "react-redux";
import {closeLobbyModal, selectActiveRoomTab, setActivePage} from "../../../../redux/actions/lobby/actions";
import {unSetRoomTabNotifier} from "../../../../redux/actions/rooms/actions";
import {setSideBarTournamentId} from "../../../../redux/actions/tournament/actions.js";

function MobileActiveRoomTabItem(props) {
    const {
        id,
        isViewRoom,
        isTournamentRoom,
        notifier,
    } = props;
    const activeRoomId = useSelector(state => state.lobby.activeRoomId);
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(selectActiveRoomTab({roomId: id}))
        dispatch(unSetRoomTabNotifier({roomId: id}))
        dispatch(closeLobbyModal())
        dispatch(setSideBarTournamentId({tournamentId: null}))
    }
    return (
        <li className={`mobile-header-active-games--item ${Number(activeRoomId) === Number(id) ? "active" : "" }`} onClick={handleClick}>
            <i className={`
                ${notifier ? 'mobile-blank-animation' : ''} 
                ${isTournamentRoom && !isViewRoom ? 'icon-cup' : 'icon-1'}
                ${isViewRoom ? 'icon-eye' : ''}
            `}/>
        </li>
    )
}

export default MobileActiveRoomTabItem